var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.validUpload)?_c('dropzone-uploader',{attrs:{"uploadPath":_vm.uploadPath}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }